// extracted by mini-css-extract-plugin
export var falconContainer = "_ur-2";
export var offerCenter = "_ur-0";
export var roktContainer = "_ur-1";